import React from "react";
import { ArrowRight } from "lucide-react";
import ScrollReveal from "@/components/ScrollReveal";

const FinalCTABand: React.FC = () => {
  return (
    <section className="py-24 px-6 relative overflow-hidden">
      <div className="absolute inset-0 z-[-1] bg-cosmic-radial opacity-30" />
      <div className="absolute inset-0 bg-cosmic-900/50 backdrop-blur-lg z-[-1]" />

      <div className="container mx-auto max-w-4xl relative">
        <div className="absolute -top-20 -left-20 w-40 h-40 rounded-full bg-cosmic-500/30 filter blur-3xl opacity-60" />
        <div className="absolute -bottom-20 -right-20 w-40 h-40 rounded-full bg-cosmic-400/20 filter blur-3xl opacity-60" />

        <ScrollReveal>
          <div className="cosmic-card p-8 md:p-12 border border-white/10 relative z-10">
            <div className="text-center mb-8">
              <span className="inline-block px-4 py-1.5 rounded-full text-xs font-medium tracking-wide text-cosmic-200 border border-cosmic-400/30 bg-cosmic-900/50 backdrop-blur-sm mb-4">
                Begin today
              </span>
              <h2 className="text-3xl md:text-4xl font-display font-bold mb-4 text-gradient">
                Feel it today. Watch reality catch up.
              </h2>
              <p className="text-white/70 text-lg max-w-2xl mx-auto">
                Five minutes a day. A practice that feels like the life you're building.
              </p>
            </div>

            <div className="max-w-xl mx-auto flex flex-col items-center">
              <a
                href="#pricing"
                className="cosmic-button w-full py-4 text-lg font-medium px-12 inline-flex items-center justify-center text-center"
              >
                Send your first DM
                <ArrowRight className="ml-2 h-5 w-5" />
              </a>
              <p className="text-white/50 text-sm text-center mt-4">
                Cancel anytime · Secure checkout via Stripe
              </p>
            </div>
          </div>
        </ScrollReveal>
      </div>
    </section>
  );
};

export default FinalCTABand;
